import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class S3Client {

  private http: HttpClient = inject(HttpClient);

  public uploadImageToPresignedUrl(data: File, presignedUrl: string, headers: string[]): Observable<boolean> {
    const headersMap = headers.reduce((acc, header) => {
      const index = header.indexOf(':');
      if (index !== -1) {
        const key = header.substring(0, index).trim();
        acc[key] = header.substring(index + 1).trim();
      }
      return acc;
    }, {} as Record<string, string>);
    return this.http.put(presignedUrl, data, {
      observe: 'response',
      headers: headersMap
    }).pipe(
      map(response => response.status === 200 || response.status === 204)
    );
  }
}
